import axios from 'axios';
import { BlogPost } from '../types/blog';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const blogService = {
  async getAllPosts(language: string = 'en'): Promise<BlogPost[]> {
    const response = await axios.get(`${API_BASE_URL}/blog/posts`, {
      params: { language },
    });
    return response.data;
  },

  async getPostBySlug(slug: string, language: string = 'en'): Promise<BlogPost> {
    const response = await axios.get(`${API_BASE_URL}/blog/posts/${slug}`, {
      params: { language },
    });
    return response.data;
  },

  async getPostsByCategory(category: string, language: string = 'en'): Promise<BlogPost[]> {
    const response = await axios.get(`${API_BASE_URL}/blog/posts/category/${category}`, {
      params: { language },
    });
    return response.data;
  },
};